module.exports = __webpack_public_path__ + "img/img2.259ec2d3.svg";